import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { authState } from "src/store/auth";
import { useRecoilState } from "recoil";
import ArrowsIcon from "src/assets/svg-icons/circualr-arrows.svg";
import { canManageRole, rolesList } from "../../../add-edit-employee/constants";

const TableActions = ({
  rowId,
  userRole,
  accountType,
}: {
  rowId: string;
  userRole: string;
  accountType: string;
}) => {
  const navigate = useNavigate();
  const [auth] = useRecoilState(authState);
  const { permissions, user } = auth;
  const roleType = user?.roleType;

  const canManageUser = canManageRole(roleType, userRole);

  const handleActivate = () => {
    navigate(
      accountType === "sunmi"
        ? `/employees/archived/sunmi/${rowId}/edit`
        : `/employees/archived/${rowId}/edit`,
    );
  };

  return permissions?.arsannEmployees.edit &&
    (canManageUser || accountType === "sunmi") ? (
    <Stack direction={"row"}>
      <Button
        onClick={handleActivate}
        color="tertiary"
        sx={{ gap: "5px", fontSize: "12px", color: "#7E8299", fontWeight: 600 }}
        variant="contained"
        size="small"
      >
        <img src={ArrowsIcon} alt="" />
        <span>Activate</span>
      </Button>
    </Stack>
  ) : null;
};
export default TableActions;
